import React from 'react'
import PropTypes from 'prop-types'

const MapTooltip = ({ data }) => {
  const { businessName, address, distance } = data

  return (
    <div className="mapTooltip">
      <p className="mapTooltip-businessName font-h3Medium">{businessName}</p>
      <div className="mapTooltip-addressDistanceWrapper">
        <p className="mapTooltip-address font-body2">{address}</p>
        {/* <p className="mapTooltip-distance font-body2">{distance} km</p> */}
      </div>
    </div>
  )
}

MapTooltip.propTypes = {
  data: PropTypes.shape({
    businessName: PropTypes.string,
    address: PropTypes.string,
    distance: PropTypes.number,
  }),
}

export default MapTooltip
